module.exports = __webpack_public_path__ + "img/favicon.3f99ed14.png";